import { useCallback, useEffect, useState } from 'react';

import { setQueryStringParameter } from 'lib/utils/setQueryStringParameter';

export function usePaginationUrl(): (page: number) => void {
  const [currentPage, updatePage] = useState(1);

  const updatePageUrl = useCallback((page: number) => {
    if (currentPage === page) {
      return;
    }

    updatePage(page);
  }, []);

  useEffect(() => {
    if (currentPage > 1) {
      setQueryStringParameter('page', currentPage.toString(), false);
    }
  }, [currentPage]);

  return updatePageUrl;
}
